import list from 'src/modules/resource/list/resourceListReducers';
import form from 'src/modules/resource/form/resourceFormReducers';
import view from 'src/modules/resource/view/resourceViewReducers';
import destroy from 'src/modules/resource/destroy/resourceDestroyReducers';
import importerReducer from 'src/modules/resource/importer/resourceImporterReducers';
import tree from 'src/modules/resource/tree/resourceTreeReducers';
import inlineEdit from 'src/modules/resource/inlineEdit/resourceInlineEditReducers';
import lock from 'src/modules/resource/lock/resourceLockReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
  tree,
  inlineEdit,
  lock,
});
